import { Subject, forkJoin } from "rxjs";
import { CanDeactivateGuard } from "./../../blogs/can-deactivate.guard";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Injector,
  NgZone,
  OnInit,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  inject,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "src/app/services/auth.service";
import { AccordionConfig } from "ngx-bootstrap/accordion";

import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

import "brace/mode/json";
import { ToastrService } from "ngx-toastr";

import {
  debounceTime,
  filter,
  switchMap,
  take,
  takeUntil,
  tap,
} from "rxjs/operators";
import { PagesService } from "../pages/pages.service";
import { SiteService } from "src/app/services/site.service";
import { AddEditAliasDialogComponent } from "./add-edit-alias-dialog.component";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { ModuleService } from "src/app/services/module.service";
import { PageApiGroupsService } from "./services/page-api-groups.service";

export function getAccordionConfig(): AccordionConfig {
  return Object.assign(new AccordionConfig(), { closeOthers: true });
}
declare const $: any;
@Component({
  selector: "app-view-builder",
  templateUrl: "./view-builder.component.html",
  styleUrls: ["./view-builder.component.css"],
})
export class ViewBuilderComponent implements OnInit, AfterViewInit {
  @ViewChildren("myInputRefs", { read: ElementRef }) myInputRefs: any;
  @ViewChild("actionsModal") actionsModal!: TemplateRef<any>;
  @ViewChild("destroyActionsModal") destroyActionsModal!: TemplateRef<any>;
  /** Wrapper holding the on-destroy action list while its modal is open (kept separate from on-load `actionList`). */
  destroyActionsParent: { actionList: any[] } | null = null;

content2!: ViewContainerRef;
  

  title: string;
  initialPageLayout = {
    containers: [
      {
        type: "full",
        rows: [{ class: "", cols: [] }],
      },
    ],
  };
  initialTemplateLayout = {
    containers: [
      {
        type: "full",
        InnerPage: true,
        published: true,
        rows: [
          {
            class: "",
            InnerPage: true,
            published: true,
            cols: [
              {
                InnerPage: true,
                published: true,
                size: 12,
                component: {},
              },
            ],
          },
        ],
      },
    ],
  };
  destroyed = new Subject();
  linearJson = {};
  componentsCategoryList = [];
  id: number;
  selectedVersion;
  previousPageLayout;
  searchTerm = "";
  paginatedCards: any[] = [];
  currentPage: number = 0;
  pageSize: number = 4;
  parentId: number;
  page: any = {};
  versions: any;
  editLayout: boolean = false;
  latestSelectedLayout: any;
  selectedComponent: any;
  settingOpened: boolean = false;
  previewMode: boolean = false;
  preveiwLink: any;
  tempComponent: any = {};
  selectedBlockSizes: any = {};
  viewSize = "Default";
  screenWidth = "100%";
  searchText = "";
  componentsCategories: any[];
  HostNames: any[] = [];
  hostName: any;
  modalRef: BsModalRef | null;
  pageJson: any;
  renamingVersion: any = {};
  JSON: any;
  alias: string = "";
  pageLayout: any = {};
  templateLayout: any = {};
  selectedBlock: any = { element: {} };
  getCurrenttarget: any = 0;
  textAlias: boolean = false;
  block: any = {};
  savingPage: boolean;
  isTemplate: boolean;
  css: any;
  pageCultures: any[] = [];
  destinationCultureId = 0;
  formBuildersettings: any;
  ifFormBuilder: boolean = false;
  formBuilderComponentSettingsId;
  formBuilderName;
  formBuilderKeys;
  cards = [];
  formBuilderId;
  formBuilderPayload: any[] = [];
  sharedComponents: any[] = [];

  constructor(
    private moduleService: ModuleService,
    private componentFactoryResolver: ComponentFactoryResolver,
private ngZone: NgZone,
private injector: Injector,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private httpClient: HttpClient,
    private authService: AuthService,
    private modalService: BsModalService,
    private snotifyService: ToastrService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    readonly router: Router,
    private pageService: PagesService,
    public siteService: SiteService,
    private pagesService: PagesService,
    private dialog: MatDialog,
    private pageApiGroups: PageApiGroupsService,
  ) {
    // window.onpopstate = () => (CanDeactivateState.defendAgainstBrowserBackButton = true);
    // router.events
    //   .pipe(
    //     filter((e) => e instanceof NavigationEnd),
    //     tap(() => (CanDeactivateState.defendAgainstBrowserBackButton = false))
    //   )
    //   .subscribe();
  }

  dragActive;
  ngOnInit() {
    this.route.paramMap.pipe(takeUntil(this.destroyed)).subscribe((params) => {
      this.id = +params.get("id");
      this.parentId = +params.get("parentId");
      this.isTemplate =
        this.route.routeConfig.path.includes("templates-builder");

      this.preveiwLink = null;
      this.JSON = JSON;

      this.templateLayout.containers = [
        {
          type: "full",
          InnerPage: true,
          published: true,
          rows: [
            {
              class: "",
              InnerPage: true,
              published: true,
              cols: [
                { InnerPage: true, published: true, size: 12, component: {} },
              ],
            },
          ],
        },
      ];
      this.pageLayout.containers = [];

      this.selectedBlock.published = true;

      if (this.isTemplate) {
        this.pageLayout.containers = [
          {
            type: "full",
            InnerPage: true,
            published: true,
            rows: [
              {
                class: "",
                InnerPage: true,
                published: true,
                cols: [
                  { InnerPage: true, published: true, size: 12, component: {} },
                ],
              },
            ],
          },
        ];

        this.GetTemplate(this.id);
        this.GetTemplatesVersions(this.id);
      } else {
        this.GetPage(this.id);
        this.GetPageVersions(this.id);
      }
    });

    this.getRelatedPages();
  }
  AllLinkIds = [];
  setIDs(data) {
    this.AllLinkIds = data;

    this.cdr.detectChanges();
  }
  onDrop(event: CdkDragDrop<any[]>) {
    this.pageLayout.containers.push({ type: "full", rows: [] });
    this.dragActive = false; // Reset drag state
  }

  // Optional: Only allow dropping under specific conditions
  isDropAllowed() {
    return true; // Customize logic as needed
  }
  replaceJson(newData) {
    if (newData == "") {
      this.closeDialog();
      return;
    }
    this.pageLayout = this.JSON.parse(newData);
    // col=newCol
    this.closeDialog();
  }
  openAliasDialog(isDraft): void {
    if (this.ifJsonChanged()) {
      const dialogRef = this.dialog.open(AddEditAliasDialogComponent, {
        width: "400px",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.savePage(isDraft, result);
        } else {
          this.savePage(isDraft);
        }
      });
    } else {
      this.openNotifyInfo("There is no new changes made !");
    }
  }
  // canDeactivate() {
  //   this.pageService.formSaved = false;
  //   return this.pageService.formSaved;
  // }

  getRelatedPages() {
    this.pagesService
      .getRelatedPages(this.parentId)
      .pipe(takeUntil(this.destroyed))
      .subscribe((res: any) => {
        this.pageCultures = res;
      });
  }
  swipeVersion(version: any) {
    this.renamingVersion = version;
    this.setFocus();
  }
  goToPage(id: any) {
    this.router.navigate(["../", id], { relativeTo: this.route });
  }

  GetPage(id: any, newAddedVersionId?) {
    this.httpClient
      .get("/Pages/GetPageSettings/" + id)
      .pipe(takeUntil(this.destroyed))
      .subscribe((page: any) => {
        this.page = page || {};
        this.page.currentCulture = this.page.cultureId;

        if (
          page.pageTemplate &&
          page.pageTemplate.currentVersion &&
          page.pageTemplate.currentVersion.settingsBody &&
          page.pageTemplate.currentVersion.settingsBody != "{}"
        ) {
          tempData = JSON.parse(page.pageTemplate.currentVersion.settingsBody);
          if (tempData.containers) {
            this.templateLayout = tempData;
          } else {
            this.templateLayout.containers = [
              {
                type: "full",
                rows: [{ class: "", cols: [] }],
              },
            ];
            var conIndex = 0;
            for (let i = 0; i < tempData.length; i++) {
              const col = tempData[i];
              if (col.InnerPage) {
                this.templateLayout.containers.push({
                  type: "full",
                  InnerPage: true,
                  rows: [{ class: "", InnerPage: true, cols: [] }],
                });
                conIndex++;
                this.templateLayout.containers[conIndex].rows[0].cols.push({
                  InnerPage: true,
                  size: col.cols,
                  component: col.comp && col.comp.length ? col.comp[0] : {},
                });
              } else {
                if (this.templateLayout.containers[conIndex].InnerPage) {
                  this.templateLayout.containers.push({
                    type: "full",
                    rows: [{ class: "", cols: [] }],
                  });
                  conIndex++;
                  this.templateLayout.containers[conIndex].rows[0].cols.push({
                    size: col.cols,
                    component:
                      col.components && col.components.length
                        ? col.components[0]
                        : {},
                  });
                } else {
                  this.templateLayout.containers[conIndex].rows[0].cols.push({
                    size: col.cols,
                    component:
                      col.components && col.components.length
                        ? col.components[0]
                        : {},
                  });
                }
              }
            }
          }
          this.latestSelectedLayout = JSON.parse(
            JSON.stringify(this.pageLayout),
          );
        }

        if (page.currentVersion && page.currentVersion.settingsBody) {
          var tempData = JSON.parse(page.currentVersion.settingsBody);
          if (tempData.containers) {
            this.pageLayout = tempData;
          } else {
            this.pageLayout.containers = [
              {
                type: "full",
                published: true,
                rows: [{ class: "", cols: [], published: true }],
              },
            ];
            for (let i = 0; i < tempData.length; i++) {
              const col = tempData[i];
              this.pageLayout.containers[0].rows[0].cols.push({
                size: col.cols,
                component:
                  col.components && col.components.length
                    ? col.components[0]
                    : {},
              });
            }
          }
          this.selectedVersion = page.currentVersion;
          this.selectedVersion.settingsBody = JSON.parse(
            JSON.stringify(this.pageLayout),
          );
        }

        this.setPreveiwLink();
        this.GetComponents();
        if (newAddedVersionId) this.getPageVersionById(newAddedVersionId);

        // if (!this.selectedVersion) {

        //   this.selectedVersion = this.page.currentVersion;

        // }
      });
  }

  GetPageVersions(id) {
    this.httpClient
      .get("/Pages/GetAllPageVersions/" + id)
      .pipe(takeUntil(this.destroyed))
      .subscribe((versionslist: any) => {
        this.versions = versionslist || [
          { createdBy: "no version", creationDate: new Date() },
        ];
      });
  }

  GetTemplatesVersions(id) {
    this.httpClient
      .get("/PageTemplate/GetTemplatesVersions/" + id)
      .pipe(takeUntil(this.destroyed))
      .subscribe((versionslist: any) => {
        this.versions = versionslist || [
          { createdBy: "no version", creationDate: new Date() },
        ];
      });
  }

  GetTemplate(id, newAddedVersionId?) {
    this.httpClient
      .get(`/PageTemplate/GetPageTemplatesById/${id}`)
      .pipe(takeUntil(this.destroyed))
      .subscribe((template: any) => {
        this.page = template || {};
        this.css = template.currentVersion.css;

        if (
          template.currentVersion.settingsBody &&
          template.currentVersion.settingsBody != "{}"
        ) {
          var tempData = JSON.parse(template.currentVersion.settingsBody);
          if (tempData.containers) {
            this.pageLayout = tempData;
          } else {
            this.pageLayout.containers = [
              {
                type: "full",
                rows: [{ class: "", cols: [] }],
              },
            ];

            var conIndex = 0;
            for (let i = 0; i < tempData.length; i++) {
              const col = tempData[i];

              if (col.InnerPage) {
                this.pageLayout.containers.push({
                  type: "full",
                  InnerPage: true,
                  rows: [{ class: "", InnerPage: true, cols: [] }],
                });
                conIndex++;
                this.pageLayout.containers[conIndex].rows[0].cols.push({
                  InnerPage: true,
                  size: col.cols,
                  component: col.comp && col.comp.length ? col.comp[0] : {},
                });
              } else {
                if (this.pageLayout.containers[conIndex].InnerPage) {
                  this.pageLayout.containers.push({
                    type: "full",
                    rows: [{ class: "", cols: [] }],
                  });
                  conIndex++;
                  this.pageLayout.containers[conIndex].rows[0].cols.push({
                    size: col.cols,
                    component:
                      col.components && col.components.length
                        ? col.components[0]
                        : {},
                  });
                } else {
                  this.pageLayout.containers[conIndex].rows[0].cols.push({
                    size: col.cols,
                    component:
                      col.components && col.components.length
                        ? col.components[0]
                        : {},
                  });
                }
              }
            }
          }
        } else {
          this.pageLayout.containers = [
            {
              type: "full",
              InnerPage: true,
              published: true,
              rows: [
                {
                  class: "",
                  InnerPage: true,
                  published: true,
                  cols: [
                    {
                      InnerPage: true,
                      published: true,
                      size: 12,
                      component: {},
                    },
                  ],
                },
              ],
            },
          ];
        }

        // this.page.currentCulture = this.authService.siteCultures.length ? this.authService.siteCultures[0] : null
        this.latestSelectedLayout = JSON.parse(JSON.stringify(this.pageLayout));
        this.selectedVersion = template.currentVersion;

        this.selectedVersion.settingsBody = JSON.parse(
          JSON.stringify(this.pageLayout),
        );
        this.setPreveiwLink();
        this.GetComponents();
        if (newAddedVersionId) {
          this.getTemplateVersionById(newAddedVersionId);
        }
      });
  }
  sharedElements = [];
  savePage(isDraft?, alias?, isPreview?: boolean, hostName?, modalRef?) {
    this.savingPage = true;
    this.components = [];
    if (this.isTemplate) {
      this.saveTemplate(isDraft, alias);
    } else {
      this.getPageContent(this.pageLayout);
      this.pageService
        .saveSharedelements(this.sharedElements)
        .pipe(takeUntil(this.destroyed))
        .subscribe((res) => {
          if (res != null) {
            this.setSharedtPageContent(res, this.pageLayout);
          }

          this.page.pageSettings = JSON.stringify(this.pageLayout);
          // this.page.pageSettings =this.page.pageSettings.replace(/\s+/g,' ');
          if (this.ifFormBuilder) {
            const data = {
              PageId: this.page.id,
              Settings: this.page.pageSettings,
              PageComponents: this.components,
              isDraft: isDraft,
              alias: alias,
            };

            try {
              this.formBuilderPayload = [
                ...new Map(
                  this.formBuilderPayload.map((item) => [
                    item["componenetSettingsId"],
                    item,
                  ]),
                ).values(),
              ];

              this.httpClient
                .post(
                  "/Forms/UpsertFormBuilderSettings",
                  this.formBuilderPayload,
                )
                .pipe(takeUntil(this.destroyed))
                .subscribe();
            } catch (error) {}
            this.httpClient
              .post("/pages/SavePageSettings", data)
              .pipe(takeUntil(this.destroyed))
              .subscribe(
                (res) => {
                  this.openNotifySuccess("Changes Saved");
                  this.GetPage(this.page.id, res[0].id);
                  this.versions = res;
                  if (isPreview)
                    this.openPreviewMode(hostName, res[0], modalRef);

                  setTimeout(() => {
                    this.savingPage = false;
                  }, 1000);
                  this.pageService.formSaved = true;
                },
                (err) => {},
              );
          } else {
            const data = {
              PageId: this.page.id,
              Settings: this.page.pageSettings,
              PageComponents: this.components,
              isDraft: isDraft,
              alias: alias,
            };

            this.httpClient
              .post("/pages/SavePageSettings", data)
              .pipe(takeUntil(this.destroyed))
              .subscribe(
                (res: any) => {
                  this.openNotifySuccess("Changes Saved");
                  if (isPreview)
                    this.openPreviewMode(hostName, res[0], modalRef);
                  //suggested by asem suppose res[0] is the new added version
                  this.GetPage(this.page.id, res[0].id);
                  this.versions = res;

                  setTimeout(() => {
                    this.savingPage = false;
                  }, 1000);
                  this.pageService.formSaved = true;
                },
                (err) => {},
              );
          }
        });
    }
    if (!this.isTemplate) {
      this.confirmKeysByPageId();
    } else {
      this.confirmKeysByTempalteId();
    }
  }

  getNonConfirmedKeys() {
    for (let row of this.pageLayout.containers[0].rows) {
    }
  }
  components: any[] = [];
  downloadJsonFile(): void {
    const jsonString = JSON.stringify(this.pageLayout, null, 2); // Format JSON with indentation
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = this.page.name;
    a.click();
    window.URL.revokeObjectURL(url); // Free up memory
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  getTemplates() {
    let data = {
      pagination: {
        start: 0,
        number: 50,
      },
      search: {
        name: "",
        description: this.searchTerm,

        settingsType: this.isTemplate ? "TEMPLATE" : "PAGE",
        thumbnailUrl: "",
        settings: "",
        fullSearch: "",
      },
    };
    this.httpClient
      .post("/PredefinedTemplates/GetAllSettings", data)
      .pipe(debounceTime(500))
      .subscribe((res: any) => {
        this.cards = res.data;
        this.updatePaginatedCards();
      });
  }
  updatePaginatedCards() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedCards = this.cards.slice(startIndex, endIndex);
  }

  nextPage() {
    if ((this.currentPage + 1) * this.pageSize < this.cards.length) {
      this.currentPage++;
      this.updatePaginatedCards();
    }
  }
  openPopup(PopupComponent) {
    this.dialog.open(PopupComponent, {
      width: "80%",
      hasBackdrop: true,
      backdropClass: "custom-backdrop",
    });
    this.getTemplates();
  }
  previousPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePaginatedCards();
    }
  }
  getPageContent(layout?) {
    const containers = layout.containers;

    if (containers.length > 0) {
      this.sharedElements = [];
      const rows = containers.map((c) => c.rows);
      const flatRows = this.flatten([], rows);

      const cols = flatRows.map((c) => c.cols);
      const flatCols = this.flatten([], cols);

      var colsCompos = flatCols.filter((x) => x.component);

      var subCols = flatCols.map((x) => x.subCols);
      var flatSubCols = this.flatten([], subCols);

      colsCompos.forEach((element) => {
        if (
          element &&
          element.component &&
          Object.keys(element).length > 0 &&
          Object.keys(element.component).length > 0
        ) {
          if (!this.components.includes(element.component.componentName)) {
            this.components.push(element.component.componentName);

            // if(this.components.filter(x=>x=="FormBuilderComponent"))
          }

          if (element.component.sharedSettings && element.component.id == 0) {
            const identifireCode =
              Math.random().toString(36).substr(2, 9) + new Date().getTime();
            this.sharedElements.push({
              elementTypeId: "Component",
              elementId: element.component.elementId,
              settings: JSON.stringify(element.component.setting),
              cultureId: this.isTemplate ? null : this.page.currentCulture,
              DataKey: element.component.componentName,
              Name: element.component.ailasName,
              identifierCode: identifireCode,
            });

            element.component.setting = identifireCode;
            element.component.sharedStatus = 0;
          }
        }
        if (element) {
          if (element.component.componentName == "FormBuilderComponent") {
            this.ifFormBuilder = true;

            let keys = [];
            if (
              element.component.setting &&
              element.component.setting.blocks &&
              element.component.setting.blocks.length
            ) {
              try {
                keys = element.component.setting.blocks.map(
                  (x) => x.element.key,
                );
              } catch (error) {
                console.log("no keys");
              }
            }
            if (element.component.setting) {
              this.formBuilderPayload.push({
                id: 0,
                name: element.component.setting.formName || "Form",
                settings: JSON.stringify(element.component.setting),
                keys: keys ? JSON.stringify(keys) : null,
                componenetSettingsId:
                  element.component.setting.componentSettingsId,
                source: 1,
                additionalData: " ",
                pageId: this.page.id,
              });
            }
          }
        }
      });

      flatSubCols.forEach((element) => {
        if (
          element &&
          element.subCols &&
          Object.keys(element).length > 0 &&
          Object.keys(element.subCols).length > 0
        ) {
          if (!this.components.includes(element.component.componentName)) {
            this.components.push(element.component.componentName);
          }

          if (element.component.sharedSettings && element.component.id == 0) {
            const identifireCode =
              Math.random().toString(36).substr(2, 9) + new Date().getTime();
            this.sharedElements.push({
              elementTypeId: "Component",
              elementId: element.component.elementId,
              settings: JSON.stringify(element.component.setting),
              cultureId: this.isTemplate ? null : this.page.currentCulture,
              DataKey: element.component.componentName,
              Name: element.component.ailasName,
              identifierCode: identifireCode,
            });

            element.component.setting = identifireCode;
            element.component.sharedStatus = 0;
          }
        }
        if (
          element &&
          element.component &&
          Object.keys(element).length > 0 &&
          Object.keys(element.component).length > 0
        ) {
          if (!this.components.includes(element.component.componentName)) {
            this.components.push(element.component.componentName);
          }

          if (element.component.sharedSettings && element.component.id == 0) {
            const identifireCode =
              Math.random().toString(36).substr(2, 9) + new Date().getTime();
            this.sharedElements.push({
              elementTypeId: "Component",
              elementId: element.component.elementId,
              settings: JSON.stringify(element.component.setting),
              cultureId: this.isTemplate ? null : this.page.currentCulture,
              DataKey: element.component.componentName,
              Name: element.component.ailasName,
              identifierCode: identifireCode,
            });

            element.component.setting = identifireCode;
            element.component.sharedStatus = 0;
          }
        }
        if (element) {
          if (element.component.componentName == "FormBuilderComponent") {
            this.ifFormBuilder = true;
            let keys = [];
            if (
              element.component.setting &&
              element.component.setting.blocks &&
              element.component.setting.blocks.length
            ) {
              try {
                keys = element.component.setting.blocks.map(
                  (x) => x.element.key,
                );
              } catch (error) {
                console.log("no keys");
              }
            }
            if (element.component.setting) {
              this.formBuilderPayload.push({
                id: 0,
                name: element.component.setting.formName || "Form",
                settings: JSON.stringify(element.component.setting),
                keys: keys ? JSON.stringify(keys) : null,
                componenetSettingsId:
                  element.component.setting.componentSettingsId,
                source: 1,
                additionalData: " ",
                pageId: this.page.id,
              });
            }
          }
        }
      });
    }
  }

  setSharedtPageContent(sharedComponents, layout?) {
    const containers = layout.containers;
    const newSharedComponents = sharedComponents;
    if (containers.length > 0) {
      const rows = containers.map((c) => c.rows);
      const flatRows = this.flatten([], rows);

      const cols = flatRows.map((c) => c.cols);
      const flatCols = this.flatten([], cols);

      var colsCompos = flatCols.filter((x) => x.component);

      var subCols = flatCols.map((x) => x.subCols);
      var flatSubCols = this.flatten([], subCols);

      colsCompos.forEach((element) => {
        if (
          element &&
          element.component &&
          Object.keys(element).length > 0 &&
          Object.keys(element.component).length > 0
        ) {
          if (element.component.id == 0) {
            newSharedComponents.forEach((sharedElement) => {
              if (this.isTemplate) {
                if (sharedElement.identifierCode == element.component.setting) {
                  element.component.id = sharedElement.id;
                  // element.component.setting = sharedElement.settings
                }
              } else {
                if (
                  sharedElement.identifierCode == element.component.setting &&
                  sharedElement.cultureId == this.page.currentCulture
                ) {
                  element.component.id = sharedElement.id;
                  // element.component.setting = sharedElement.settings
                }
              }
            });
          }
        }
      });

      flatSubCols.forEach((element) => {
        if (
          element &&
          element.subCols &&
          Object.keys(element).length > 0 &&
          Object.keys(element.subCols).length > 0
        ) {
          if (element.component.id == 0) {
            newSharedComponents.forEach((sharedElement) => {
              if (this.isTemplate) {
                if (sharedElement.identifierCode == element.component.setting) {
                  element.component.id = sharedElement.id;
                }
              } else {
                if (
                  sharedElement.identifierCode == element.component.setting &&
                  sharedElement.cultureId == this.page.currentCulture
                ) {
                  element.component.id = sharedElement.id;
                }
              }
            });
          }
        }
        if (
          element &&
          element.component &&
          Object.keys(element).length > 0 &&
          Object.keys(element.component).length > 0
        ) {
          if (element.component.id == 0) {
            newSharedComponents.forEach((sharedElement) => {
              if (this.isTemplate) {
                if (sharedElement.identifierCode == element.component.setting) {
                  element.component.id = sharedElement.id;
                }
              } else {
                if (
                  sharedElement.identifierCode == element.component.setting &&
                  sharedElement.cultureId == this.page.currentCulture
                ) {
                  element.component.id = sharedElement.id;
                }
              }
            });
          }
        }
      });
    }
  }

  flatten(arr, data) {
    for (let i = 0; i < data.length; i++) {
      if (!Array.isArray(data[i])) {
        arr.push(data[i]);
      } else {
        this.flatten(arr, data[i]);
      }
    }

    return arr;
  }

  saveTemplate(isDraft, alias) {
    this.getPageContent(this.pageLayout);

    this.pageService
      .saveSharedelements(this.sharedElements)
      .pipe(takeUntil(this.destroyed))
      .subscribe((res) => {
        if (res != null) {
          this.setSharedtPageContent(res, this.pageLayout);
        }
        var data = {
          TemplateId: this.id,
          Css: this.css,
          Settings: JSON.stringify(this.pageLayout),
          TemplateComponents: this.components,
          alias: alias,
          isDraft: isDraft,
        };
        // const newArryTemp:[]=[];
        data.TemplateComponents.findIndex((x, index) => {
          if (x == null || x == undefined)
            data.TemplateComponents.splice(index, 1);
        });

        this.httpClient
          .post("/PageTemplate/SaveTemplatesSettings", data)
          .pipe(takeUntil(this.destroyed))
          .subscribe((res: any) => {
            this.openNotifySuccess("Changes Saved");
            // if (isPreview)
            // this.openPreviewMode(hostName, res[0], modalRef)
            this.GetTemplate(this.id, res[0].id);
            this.versions = res;
            // this.getTemplateVersionById(res[0].id);

            setTimeout(() => {
              this.savingPage = false;
            }, 5000);
          });
      });
  }

  back() {
    window.history.back();
  }

  FilterComponents() {
    this.componentsCategories = [];
    if (this.searchText != "") {
      this.componentsCategoryList.forEach((cat) => {
        var list = [];
        var category = cat.category;
        for (let i = 0; i < cat.components.length; i++) {
          var element = cat.components[i];
          if (
            element.name.toUpperCase().indexOf(this.searchText.toUpperCase()) >=
            0
          ) {
            list.push(element);
          }
        }
        if (list.length)
          this.componentsCategories.push({
            category: category,
            components: list,
          });
      });
    } else this.componentsCategories = this.componentsCategoryList;
  }

  setPreveiwLink() {
    this.HostNames = [];
    this.httpClient
      .get("/Sites/GetSiteDetails/" + this.authService.siteId)
      .pipe(takeUntil(this.destroyed))
      .subscribe((res: any) => {
        const hostNameByCulure = res.hostNames.filter(
          (ele) => ele.cultureId == this.page.currentCulture,
        );
        for (let index = 0; index < hostNameByCulure.length; index++) {
          const h = hostNameByCulure[index];
          let prefix = "";
          if (h.prefix) {
            prefix = h.prefix + "/";
          }
          this.HostNames.push({
            HostName: h.hostName + (prefix ? "/" + prefix : ""),
            LogoId: h.logoId,
            CultureCodeId: h.cultureCodeId,
            link: this.sanitizer.bypassSecurityTrustUrl(
              "http://" + h.hostName + "/" + prefix + this.page.slug,
            ),
          });
        }
      });
  }

  editingLayout() {
    this.editLayout = true;
    this.latestSelectedLayout = JSON.parse(JSON.stringify(this.pageLayout));
  }

  saveEditingLayout() {
    this.editLayout = false;
    this.latestSelectedLayout = JSON.parse(JSON.stringify(this.pageLayout));
  }

  cancelEditingLayout() {
    this.editLayout = false;
    this.pageLayout = JSON.parse(JSON.stringify(this.latestSelectedLayout));
  }

  GetComponents() {
    const isCulture = this.isTemplate ? null : this.page.currentCulture;
    forkJoin([
      this.pagesService.getAllComponents(),
      this.pagesService.getSharedElements(isCulture),
    ])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result: any) => {
        this.componentsCategoryList = result[0].concat(result[1]);
        this.componentsCategories = result[0].concat(result[1]);
      });

    // this.httpClient.get('/Components/GetAllComponents').subscribe((Components: any) => {
    //   this.httpClient.get('/Elements/GetSharedElements/' + this.page.currentCulture).subscribe((elements: any) => {
    //     this.componentsCategoryList = Components;
    //     this.componentsCategories = Components;
    //     console.log("elements " + elements);

    //   });
    // });
  }

  selectVersion(version) {
    if (this.isTemplate) {
      // this.httpClient
      //   .post(`/PageTemplate/UpdatePageVersion/${this.id}/${v}`, {})
      //   .subscribe((template: any) => {
      // this.GetTemplate(this.id);

      this.getTemplateVersionById(version.id);

      // });
    } else {
      this.getPageVersionById(version.id);

      // this.httpClient
      //   .post(`/Pages/UpdatePageVersion/${this.id}/${v}`, {})
      //   .subscribe((page: any) => {
      // this.GetPage(this.id);
      // });
    }
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  openNotifyInfo(message: string) {
    this.snotifyService.info(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openSetting(event) {
    var col = event.col;
    var comp = event.comp;
    var event = event.event;

    this.getCurrenttarget = event ? event.clientY : 0;
    // if (this.authService.siteCultures.length) {
    this.page.currentCulture = this.page.cultureId;
    this.latestSelectedLayout = JSON.parse(JSON.stringify(this.pageLayout));
    this.selectedComponent = comp ? comp : this.selectedComponent;
    this.selectedBlock = col;
    // Snapshot every request group on the page before the settings panel builds
    // its component, so its group / API / response-key pickers can offer groups
    // configured on other components.
    this.pageApiGroups.refresh(this.pageLayout);
    this.settingOpened = true;
    // } else
    //   this.openNotifySuccess("the site have no Hosts , please add one ")
  }

  checkResult($event) {
    var el = document.getElementById("basic-container");
    if (this.getCurrenttarget) {
      el.scrollTo(0, this.getCurrenttarget);
      this.getCurrenttarget = 0;
    }

    if ($event.result == "done") {
      this.selectedComponent = $event.data;

      this.settingOpened = false;
      this.latestSelectedLayout = JSON.parse(JSON.stringify(this.pageLayout));
    } else if ($event.result == "refresh") {
      this.GetComponents();
      this.selectedComponent = $event.data;
      // this.selectedComponent.sharedSettings = true;

      this.latestSelectedLayout = JSON.parse(JSON.stringify(this.pageLayout));
    } else if ($event.result == "updateShared") {
      this.selectedComponent = $event.data;

      this.settingOpened = false;
      this.pageLayout = JSON.parse(JSON.stringify(this.latestSelectedLayout));
    } else {
      this.settingOpened = false;
      this.pageLayout = JSON.parse(JSON.stringify(this.latestSelectedLayout));
    }
  }

  blockStatus(comp) {
    if (comp.blockStatus == 2 || comp.blockStatus == undefined) {
      comp.blockStatus = 1;
      this.openNotifySuccess("Published");
    } else {
      comp.blockStatus == 2;
      this.openNotifySuccess("Un-Published");
    }
  }

  builder() {
    this.previewMode = false;
  }

  preview(template) {
    this.previewMode = false;
    // this.hostName = this.hostName ? this.hostName : this.HostNames[0].HostName;

    // if (this.HostNames.length)
    //   this.preveiwLink = this.sanitizer.bypassSecurityTrustResourceUrl(
    //     (window["config"].previewLink || "") +
    //     this.hostName +
    //     "/" +
    //     this.page.slug
    //   );

    // this.previewMode = true;

    this.modalRef = this.modalService.show(template);
  }

  goToPreview(hostName, modalRef: BsModalRef) {
    if (this.ifJsonChanged()) {
      this.savePage(true, null, true, hostName, modalRef);
    } else this.openPreviewMode(hostName, this.selectedVersion, modalRef);
  }
  openPreviewMode(hostName, version, modalRef: BsModalRef) {
    if (hostName) {
      modalRef.hide();

      this.httpClient
        .get("/Pages/GetPreviewCode/" + version.id)
        .pipe(takeUntil(this.destroyed))
        .subscribe((res) => {
          if (res) {
            window.open(
              hostName.link.changingThisBreaksApplicationSecurity +
                "?PreviewCode=" +
                res,
              "_blank",
            );

            // this.router.navigate([hostName.link.changingThisBreaksApplicationSecurity], { queryParams: { preview: res } });

            //  this.preveiwLink = this.sanitizer.bypassSecurityTrustResourceUrl(
            //  (window["config"].previewLink || "") + hostName['HostName'] + "/" + this.page.slug + '?PreviewCode=' + res );

            //  this.previewMode = true;
          }
        });
    }
  }

  setPageCurrentCulture(h) {
    this.hostName = h.HostName;
    this.preveiwLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      (window["config"].previewLink || "") + h.HostName + "/" + this.page.slug,
    );
  }

  saveBlockSetting(pop, form, block) {
    if (form.invalid) {
      Object.keys(form.controls).forEach((f) => {
        form.controls[f].markAsTouched(true);
      });
      return;
    }
    block.sizes = form.value;
    pop.hide();
  }

  setSelectedBlockSizes(sizes) {
    this.selectedBlockSizes = sizes ? JSON.parse(JSON.stringify(sizes)) : {};
  }

  getViewCols(block) {
    if (this.viewSize != "Default") {
      if (block.sizes) {
        return block.sizes[this.viewSize]
          ? block.sizes[this.viewSize]
          : block.size;
      } else return block.size ? "-" + block.size : "";
    } else return block.size ? "-" + block.size : "";
  }

  openCode(template) {
    this.pageJson = JSON.stringify(this.pageLayout, undefined, 4);
    this.modalRef = this.modalService.show(template, { class: " modal-xl" });
  }

  savePageJson() {
    this.pageLayout = JSON.parse(this.pageJson);
    this.modalRef.hide();
  }

  clonePage(template) {
    this.modalRef = this.modalService.show(template, {
      ignoreBackdropClick: true,
      class: " modal-sm modal-dialog-centered",
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.destinationCultureId = 0;
  }
  clone() {
    // let data = {
    //   destinationId: this.destinationCultureId,
    //   sourceId: this.id,
    //   pageBody: JSON.stringify(this.pageLayout)
    // }
    this.pagesService
      .clonePage(this.id, this.destinationCultureId)
      .pipe(takeUntil(this.destroyed))
      .subscribe((res: any) => {
        this.goToPage(this.destinationCultureId);
        this.closeModal();
      });
  }

  //keys change status part
  confirmKeysByPageId() {
    this.httpClient
      .put(`/ComponentKeys/ChangeStatus/${this.page.id}`, {})
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => {});
  }
  confirmKeysByTempalteId() {
    this.httpClient
      .put(`/ComponentKeys/ChangeStatusByPageTemplateId/${this.id}`, {})
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => {});
  }
  ifJsonChanged() {
    if (this.selectedVersion) {
      if (
        JSON.stringify(this.pageLayout) ==
        JSON.stringify(this.selectedVersion.settingsBody)
      ) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }
  publishOrSave() {
    if (this.ifJsonChanged()) {
      this.openAliasDialog(false);
      // this.savePage(false)
    } else {
      if (this.page.currentVersion.id == this.selectedVersion.id) {
        this.openNotifyInfo("This version already published !");
        return;
      } else {
        if (!this.isTemplate) {
          this.httpClient
            .post(
              `/Pages/UpdatePageVersion/${this.id}/${this.selectedVersion.id}`,
              {},
            )
            .pipe(takeUntil(this.destroyed))
            .subscribe(
              (page: any) => {
                this.page.currentVersion = this.selectedVersion;
                this.GetPageVersions(this.id);
                this.openNotifySuccess("The page is published successfully !");
              },
              (err) => {
                console.log(err);
              },
            );
        } else {
          this.httpClient
            .post(
              `/PageTemplate/UpdatePageVersion/${this.id}/${this.selectedVersion.id}`,
              {},
            )
            .pipe(takeUntil(this.destroyed))
            .subscribe((template: any) => {
              this.page.currentVersion = this.selectedVersion;

              this.GetTemplatesVersions(this.id);
              this.openNotifySuccess(
                "The template is published successfully !",
              );
            });
        }
      }
    }
  }

  getTemplateVersionById(id: number) {
    this.httpClient
      .get(`/Pages/GetTemplateVersionSettings/${id}`)
      .pipe(takeUntil(this.destroyed))
      .subscribe((res: any) => {
        if (Object.keys(this.JSON.parse(res.settingsBody)).length == 0)
          res.settingsBody = JSON.stringify(this.initialTemplateLayout);

        this.pageLayout = JSON.parse(res.settingsBody);
        this.selectedVersion = res;
        this.selectedVersion.settingsBody = JSON.parse(res.settingsBody);
      });
  }
  getPageVersionById(id: number) {
    console.log(
      this.selectedVersion,
      "selected before",
      this.selectedVersion.id,
    );

    this.httpClient
      .get(`/pages/GetPageVersionSettings/${id}`)
      .pipe(takeUntil(this.destroyed))
      .subscribe((res: any) => {
        if (Object.keys(this.JSON.parse(res.settingsBody)).length == 0)
          res.settingsBody = JSON.stringify(this.initialPageLayout);

        this.pageLayout = JSON.parse(res.settingsBody);
        this.selectedVersion = res;

        this.selectedVersion.settingsBody = JSON.parse(res.settingsBody);
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }
  // typing
  // unsunscribe
  // comments
  //check if it's avalid json / it's strigfied or not
  handleJson(obj, prevKey) {
    if (!prevKey) {
      this.linearJson = {};
    }
    if (Object.keys(obj).length == 0) {
      var newKey = (prevKey ? prevKey + "." : "") + JSON.stringify(obj);
      this.linearJson[newKey] = newKey;
      return;
    }
    for (let key of Object.keys(obj)) {
      var newKey = (prevKey ? prevKey + "." : "") + key;
      if (Array.isArray(obj[key])) {
        this.handleArray(obj[key], newKey);
      } else if (typeof obj[key] == "object") {
        this.handleJson(obj[key], newKey);
      } else {
        newKey = newKey + "." + obj[key];
        this.linearJson[newKey] = newKey;
      }
    }
  }
  handleArray(arr, prevKey) {
    if (!arr.length) {
      let newKey = prevKey + "." + this.JSON.stringify(arr);
      this.linearJson[newKey] = newKey;
      return;
    }
    for (let i = 0; i < arr.length; i++) {
      if (Array.isArray(arr[i])) {
        this.handleArray(arr[i], prevKey);
      } else if (typeof arr[i] == "object") {
        this.handleJson(arr[i], prevKey);
      } else {
        let newKey = prevKey + "." + arr[i] + i;
        this.linearJson[newKey] = newKey;
      }
    }
  }

  checkIfComponentisNew(containerIndex, rowIndex, colIndex, component) {
    if (
      this.pageLayout.containers[containerIndex].rows[rowIndex].cols[colIndex]
    ) {
    }
    // for(let i=0;i<this.pageLayout.containers.length;i++){
    //   if(this.pageLayout.containers[i].rows.length){
    //     for(let j=0;j< this.pageLayout.containers[i].rows.length;j++){
    //       if(this.pageLayout.containers[i].rows[j].cols.length){
    //         for(let k=0;k<this.pageLayout.containers[i].rows[j].cols.length ;k++){
    //           this.linearJson['containers'+i+'.'+rows]

    //         }
    //       }
    //     }
    //   }

    // }
  }
  renameVersion(version, event: any) {
    if (version.alias != event.target.value) {
      event.stopPropagation();
      event.target.focus();
      var data = {
        id: this.renamingVersion.id,
        alias: event.target.value,
      };
      var url = this.isTemplate
        ? "/PageTemplate/EditAlias"
        : "/Pages/EditAlias";
      this.httpClient.post(url, data).subscribe((res) => {
        this.openNotifySuccess("Version name updated successfully !");
        this.renamingVersion = {};
        this.versions = res;
        if (version.id == this.selectedVersion.id)
          this.selectedVersion.alias = event.target.value;
      });
    } else {
      this.renamingVersion = {};
    }
  }
  stop(event: any) {
    event.stopPropagation();
    event.target.focus();
  }

  setFocus() {
    this.myInputRefs.changes.pipe(take(1)).subscribe((res) => {
      for (let ref of this.myInputRefs) {
        this.renderer.selectRootElement(ref.nativeElement).focus();
      }
    });
  }

  flagVersionMenu() {
    this.renamingVersion = {};
  }

  ngAfterViewInit() {
  console.log('VIEW INIT', this.content2);
}

  loadActionsComp = async (vcr: ViewContainerRef) => {

  if (!vcr) {
    console.warn('content2Ref still undefined');
    return;
  }

    vcr.clear();

    const key = "ActionsModalComponent";
    const componentType = this.moduleService.ComponentFactory[key];

    if (!componentType) return;

    const componentRef: any = vcr.createComponent(componentType,
  {
    injector: this.injector
  });

    const componentData = this.pageLayout || {};


    componentRef.instance.parentObj= componentRef.instance.parentObj|| { actionList: [] };

    componentRef.instance.data = {
      page: {},
      component: componentData,
      moduleService: this.moduleService,
      authService: this.authService,
      ComponentFactory: this.moduleService.ComponentFactory,
      enviroment: "",
      dayGridPlugin,
      interactionPlugin,
    };

    componentRef.instance.parentObj = componentData;
    componentRef.instance.isChild = true;

    componentRef.changeDetectorRef.detectChanges();
  };
  openActionsModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template, {
    class: "modal-xl modal-dialog-centered",
  });


}

  loadDestroyActionsComp = async (vcr: ViewContainerRef) => {

  if (!vcr) {
    console.warn('destroy actions vcr still undefined');
    return;
  }

    vcr.clear();

    const key = "ActionsModalComponent";
    const componentType = this.moduleService.ComponentFactory[key];

    if (!componentType) return;

    const componentRef: any = vcr.createComponent(componentType,
  {
    injector: this.injector
  });

    const componentData = this.pageLayout || {};

    // Keep on-destroy actions in their own key, separate from the on-load `actionList`.
    this.destroyActionsParent = {
      actionList: componentData.onDestroyActionList || [],
    };

    componentRef.instance.data = {
      page: {},
      component: componentData,
      moduleService: this.moduleService,
      authService: this.authService,
      ComponentFactory: this.moduleService.ComponentFactory,
      enviroment: "",
      dayGridPlugin,
      interactionPlugin,
    };

    componentRef.instance.parentObj = this.destroyActionsParent;
    componentRef.instance.isChild = true;

    componentRef.changeDetectorRef.detectChanges();
  };

  openDestroyActionsModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template, {
    class: "modal-xl modal-dialog-centered",
  });

  // Persist the edited list back onto the page layout under its dedicated key on close.
  const sub = this.modalService.onHide.subscribe(() => {
    if (this.destroyActionsParent && this.pageLayout) {
      this.pageLayout.onDestroyActionList =
        this.destroyActionsParent.actionList || [];
    }
    this.destroyActionsParent = null;
    sub.unsubscribe();
  });
}
  // check if the json is prasable/ strigify
  //unsubscribe
  //typings
  //logs
}
